export const getStyles = () => ({
  childrenWishesContainer: {
    overflow: "hidden",
  },
  childrenWishesSection: {
    display: "grid",
    position: "relative",
    paddingTop: "48px",

    "& h2": {
      fontSize: "1.25rem",
      fontWeight: 700,
      textAlign: "center",
    },

    "& .carousel": {
      "& img": {
        width: "100%",
        height: "auto",
        display: "inline-block",
      },
    },

    "& .react-multi-carousel-item[aria-hidden='true']": {
      opacity: 0.5,
      scale: 0.8,
    },

    "@media (min-width: 960px)": {
      gridColumn: "2 / -2",
      paddingTop: "72px",

      "& h2": {
        gridColumn: "1 / -1",
        fontSize: "2.5rem",
      },
    },
  },
  arrowPrevious: {
    position: "absolute",
    left: 10,
    cursor: "pointer",
    zIndex: 1,
    transform: "rotate(180deg)",
    height: "20px",
    width: "20px",
    "@media (min-width: 960px)": {
      height: "40px",
      width: "40px",
    },
  },
  arrowNext: {
    position: "absolute",
    right: 10,
    cursor: "pointer",
    zIndex: 1,
    height: "20px",
    width: "20px",

    "@media (min-width: 960px)": {
      height: "40px",
      width: "40px",
    },
  },

  messageBox: {
    padding: "8px 4px",

    "@media (min-width: 960px)": {
      padding: "16px 8px",
    },
  },
});
